module.exports = __webpack_public_path__ + "img/Piliated-Woodpecker.e4afdc36.jpg";